<template>
  <div>
    <b-popover
      ref="popover"
      class="manual-entry-view-popover"
      :target="`popover-${timesheet.id + `-` + index}`"
      triggers="focus blur"
      :show.sync="popoverShow"
      placement="top"
      @hide="onHide"
      @show="onShow"
    >
      <div class="modal-header">
        <h4 class="modal-title">
          {{ label.get("manual_entries") }}
        </h4>
        <button class="close-modal" @click="onHide">
          <i class="atto atto-close-btn" />
        </button>
      </div>
      <div class="modal-body">
        <div v-if="item.activities" class="manually session">
          <h4 class="heading">
            <i class="atto atto-manual-entry" />
            {{ label.get("edited_entry") }}
          </h4>
          <div class="log">
            <span class="hour">{{ item.time }}</span>
            <span class="dot-connect" />
            <h4 class="log-description">
              {{ item.name }}
            </h4>
          </div>
        </div>
        <div v-if="item.activities" class="original session">
          <div class="custom-header">
            <h4 class="heading">
              <i class="atto atto-original-entry" />
              {{ label.get("original_entry") }}
            </h4>
            <!--<button class="original-revert">-->
            <!--<i class="atto atto-revert-action"></i>-->
            <!--<span class="revert-label">Revert to original</span>-->
            <!--</button>-->
          </div>
          <div class="log">
            <span class="hour">{{ item.activities.time }}</span>
            <span class="dot-connect" />
            <h4 class="log-description">
              {{ item.activities.name }}
            </h4>
          </div>
        </div>

        <div
          v-if="item.modified && !item.activities"
          class="manually session no-border"
        >
          <h4 class="heading">
            <i class="atto atto-manual-entry" />
            {{ label.get("new_entry") }}
          </h4>
          <div class="log">
            <span class="hour">{{ item.time }}</span>
            <span class="dot-connect" />
            <h4 class="log-description">
              {{ item.name }}
            </h4>
          </div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "ManualEntryComponent",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    timesheet: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      popoverShow: false,
    };
  },
  methods: {
    onHide() {
      this.popoverShow = false;
      this.$store.commit("overlay", false);
    },
    onShow() {
      this.$store.commit("overlay", true);
    },
  },
};
</script>

<style lang="scss">
body.popover-active {
  #app {
    position: relative;
    z-index: 1;
  }

  div.popover {
    z-index: 3;
  }
}

body {
  .popover {
    border-radius: 0;
    border: 0;
    width: 500px;
    max-width: 500px;

    .popover-body {
      padding: 0;
      position: relative;
      z-index: 2;

      .modal-header {
        background-color: #cc63ad;
        padding: 1rem 1.5rem;
        display: flex;
        flex-direction: row;
        border-bottom: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        > div {
          display: flex;
          flex-direction: row;
          width: 100%;
        }

        .modal-title {
          color: #fff;
          font-size: 1rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
        }

        button.close-modal {
          margin-left: auto;
          padding: 0 0px;
          cursor: pointer;

          i {
            font-size: 14px;
            color: #fff;
            line-height: 24px;
          }
        }
      }

      .modal-body {
        padding: 1.5rem;

        .session {
          display: flex;
          flex-direction: column;
          padding: 0;

          .heading {
            font-size: 1rem;
            line-height: 1.5rem;
            font-family: $roboto-font;
            font-weight: $roboto-medium;
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            i {
              font-size: 16px;
              margin-right: 8px;
            }
          }

          &.manually {
            .heading {
              color: #cc63ad;

              i {
                color: #cc63ad;
              }
            }
            border-bottom: 2px solid #efefef;
            padding-bottom: 24px;
            padding-right: 0;
            padding-left: 0px;

            &.no-border {
              border-bottom: 0;
              padding-bottom: 0;
            }
          }

          &.original {
            padding-top: 24px;

            .heading {
              color: #00b9cb;

              i {
                color: #00b9cb;
              }
            }

            .custom-header {
              display: flex;
              flex-direction: row;
              margin-bottom: 8px;

              h4 {
                margin-bottom: 0;
              }

              button.original-revert {
                font-size: 0.75rem;
                line-height: 1rem;
                color: #999;
                font-family: $roboto-font;
                font-weight: $roboto-medium;
                display: flex;
                align-items: center;
                margin-left: auto;
                cursor: pointer;

                i {
                  font-size: 19px;
                  line-height: 24px;
                  color: #999;
                  margin-right: 7px;
                }
              }
            }
          }

          .log {
            display: flex;
            flex-direction: row;
            align-items: center;

            .hour {
              font-family: $roboto-font;
              font-weight: $roboto-regular;
              font-size: 0.75rem;
              line-height: 1rem;
              color: $atto-not-active;
              width: 60px;
              margin-right: 16px;
            }

            .dot-connect {
              display: inline-flex;
              align-self: center;
              width: 8px;
              height: 8px;
              background-color: $atto-dark-grey;
              border-radius: 8px;
              margin-right: 20px;
            }

            .log-description {
              color: $atto-font-color;
              font-family: $roboto-font;
              font-weight: $roboto-regular;
              font-size: 0.875rem;
              line-height: 1.5rem;
              flex-grow: 1;
            }
          }
        }
      }
    }

    &.bs-popover-bottom .arrow {
      &:before,
      &:after {
        border-bottom-color: #cc63ad;
      }
    }
  }
}

.popover-overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1000;
}

.bs-popover-auto[x-placement^="bottom"] .arrow::before {
  border-color: transparent;
}

.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #cc63ad;
}
</style>
<style lang="scss" scoped>
.atto-manual-entry {
  &:before {
    font-size: 16px;
  }
}
</style>
